import { createSelector } from '@reduxjs/toolkit';

const selectTrimming = state => state.trimming;

export const selectSendingNewTrim = createSelector(
  selectTrimming,
  trimming => trimming.sendingNewTrim
);

export const selectTrimRanges = createSelector(
  selectTrimming,
  trimming => trimming.trim_ranges
);

export const selectSelectedPlayRange = createSelector(
  selectTrimming,
  trimming => trimming.selectedPlayRange
);

export const selectPlayRanges = createSelector(
  selectTrimming,
  trimming => trimming.playRanges
);

export const selectTrimNewChanges = createSelector(
  selectTrimming,
  trimming => trimming.new_changes
);

export const selectCanUndoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoPointer }) => {
    return playRangeUndoPointer > 0;
  }
);

export const selectCanRedoPlayRange = createSelector(
  selectTrimming,
  ({ playRangeUndoStack, playRangeUndoPointer }) => {
    return playRangeUndoPointer < playRangeUndoStack.length - 1;
  }
);
